import React, { useState, memo, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import IconButton from '@material-ui/core/IconButton'
import 'react-image-crop/dist/ReactCrop.css'

import PhotoPickerSvg from 'components/CommonUI/svgIcons/PhotoPickerSvg'
import CropFileModal from './CropFileModal'
import { useShallowEqualSelector } from 'custom-hooks'
import {
  getProfileDataSelector,
  sendProfileAvatar,
} from 'redux/reducers/profile'

const ProfileAvatarSection = () => {
  const dispatch = useDispatch()
  const { first_name, last_name, id, image_uri } = useShallowEqualSelector(
    getProfileDataSelector
  )

  const [newAva, setNewAva] = useState(null)
  const [isOpenCropModal, setIsOpenCropModal] = useState(false)

  const _sendAvatar = useCallback(
    (file) => {
      dispatch(
        sendProfileAvatar({
          file,
          params: {
            format: 'jpg',
            class: 'user',
            id: id,
          },
        })
      )
    },
    [dispatch, id]
  )

  const handleChangeAvatar = (e) => {
    const file = e.target?.files[0]
    if (file) {
      const reader = new FileReader()
      reader.addEventListener('load', () => {
        setNewAva(reader.result)
        setIsOpenCropModal(true)
      })
      reader.readAsDataURL(file)
    }
  }
  const handleCloseModal = useCallback(() => {
    setIsOpenCropModal(false)
  }, [])

  const handleSaveNewAvatar = useCallback(
    (newFile) => {
      setIsOpenCropModal(false)
      _sendAvatar(newFile)
    },
    [_sendAvatar]
  )

  return (
    <div className="change_logo_section">
      <div className="profile_avatar logo">
        {image_uri && (
          <img className="profile_avatar_image" alt="avatar" src={image_uri} />
        )}
        <input
          accept="image/*"
          className="profile_avatar_input"
          id="icon-button-file"
          type="file"
          onChange={handleChangeAvatar}
        />
        <label
          htmlFor="icon-button-file"
          className="profile_avatar_input_button"
        >
          <IconButton
            color="primary"
            aria-label="upload picture"
            component="span"
            className="button_container"
          >
            <PhotoPickerSvg />
            <span className="profile_avatar_input_button_label">
              Change photo
            </span>
          </IconButton>
        </label>
      </div>
      <div className="full_name_employee">
        <span
          className="full_name_title full_name_text"
          title={`${first_name} ${last_name}`}
        >{`${first_name} ${last_name}`}</span>
        <span className="role_title full_name_text">Manager (Admin)</span>
      </div>
      {isOpenCropModal && (
        <CropFileModal
          file={newAva}
          handleClose={handleCloseModal}
          handleSave={handleSaveNewAvatar}
        />
      )}
    </div>
  )
}

export default memo(ProfileAvatarSection)
